module.exports = __webpack_public_path__ + "images/cef4842ed5c817bd6b765a57d7a0fe93.png";